import { Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IoCloseSharp } from "react-icons/io5";
import toast from "react-hot-toast";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import { saveData } from "../../firebase/utility";
import GeneralButton from "../button/GeneralButton";
import FormInput from "../formInput/FormInput";
import { DEFAULT_PERMISSIONS, syncPermissions } from "../../utils/permissions";

const UpdateUserModal = ({ modal, toggle, isUpdate }) => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const [userData, setUserData] = useState({
    username: "",
    email: "",
    role: "",
    address: "",
    phone: "",
    hasManualQuotesAccess: false,
    autoWhitelistAllCustomers: false,
  });

  const [permissions, setPermissions] = useState([...DEFAULT_PERMISSIONS]);

  const handlePermissionChange = (e, index) => {
    let arr = [...permissions];
    arr[index].value = e.target.checked;
    setPermissions(arr);
  };

  const validateUser = () => {
    const { username, email, role, address, phone } = userData;
    if (!username || !email || !role || !address || !phone) {
      toast.error("Please fill in all fields.");
      return false;
    }
    return true;
  };

  const handleUserUpdate = () => {
    if (validateUser()) {
      let _id = isUpdate?._id;
      let obj = { ...userData, _id, permissions };
      try {
        saveData("Users", _id, obj).then((res) => {
          if (res) {
            toast.success("User Updated Successfully");
            setUserData({
              username: "",
              email: "",
              role: "",
              address: "",
              phone: "",
              hasManualQuotesAccess: false,
              autoWhitelistAllCustomers: false,
            });
            toggle();
          }
        });
      } catch (error) {
        toggle();
      }
    }
  };

  useEffect(() => {
    if (isUpdate) {
      setUserData({
        username: isUpdate?.username || "",
        email: isUpdate?.email || "",
        role: isUpdate?.role || "",
        address: isUpdate?.address || "",
        phone: isUpdate?.phone || "",
        hasManualQuotesAccess: isUpdate?.hasManualQuotesAccess || false,
        autoWhitelistAllCustomers: isUpdate?.autoWhitelistAllCustomers || false,
      });

      setPermissions(
        isUpdate?.permissions?.length > 0 ? syncPermissions(isUpdate.permissions) : [...DEFAULT_PERMISSIONS]
      );
    }
  }, [isUpdate]);

  return (
    <Modal isOpen={modal} toggle={toggle} centered size="lg">
      <ModalBody className="p-4 bg-white rounded shadow-sm">
        <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
          <h4 className="fw-bold m-0">
            {isUpdate ? "Update User" : "Add User"}
          </h4>
          <IoCloseSharp
            size={28}
            className="pointer text-secondary"
            onClick={toggle}
          />
        </div>

        <Row className="">
          <Col md={6}>
            <FormInput
              type="text"
              label="Username"
              placeholder="Enter username"
              size={"medium"}
              value={userData.username}
              handleChange={(e) =>
                setUserData({ ...userData, username: e.target.value })
              }
            />
          </Col>

          <Col md={6}>
            <FormInput
              type="email"
              label="Email"
              placeholder="Enter email"
              size={"medium"}
              value={userData.email}
              handleChange={(e) =>
                setUserData({ ...userData, email: e.target.value })
              }
            />
          </Col>

          <Col md={6}>
            <FormInput
              dropdown
              label="Role"
              className="bg-white border"
              size={"medium"}
              options={
                currentUser?.role === "Super-admin"
                  ? [
                    { label: "Supervisor", value: "Supervisor" },
                    { label: "Admin", value: "Admin" },
                  ]
                  : [
                    { label: "Supervisor", value: "Supervisor" },
                  ]
              }
              placeholder="Select role"
              value={userData.role}
              handleChange={(value) =>
                setUserData({ ...userData, role: value })
              }
            />
          </Col>

          <Col md={6}>
            <FormInput
              type="text"
              label="Address"
              placeholder="Enter address"
              size={"medium"}
              value={userData.address}
              handleChange={(e) =>
                setUserData({ ...userData, address: e.target.value })
              }
            />
          </Col>

          <Col md={6}>
            <FormInput
              type="number"
              label="Phone"
              placeholder="Enter phone number"
              size={"medium"}
              value={userData.phone}
              handleChange={(e) =>
                setUserData({ ...userData, phone: e.target.value })
              }
            />
          </Col>

        </Row>

        <div className="mt-2">
          <h6 className="fw-semibold mb-2">Additional Options</h6>
          <Row className="g-2">
            <Col md={6}>
              <div className="border rounded p-2 d-flex align-items-center bg-white shadow-sm border-primary h-100">
                <Checkbox
                  checked={userData?.hasManualQuotesAccess}
                  onChange={(e) =>
                    setUserData({
                      ...userData,
                      hasManualQuotesAccess: e.target.checked,
                    })
                  }
                >
                  <span className="fw-semibold">Has Manual Quotes Access</span>
                </Checkbox>
              </div>
            </Col>
            <Col md={6}>
              <div className="border rounded p-2 d-flex align-items-center bg-white shadow-sm border-primary h-100">
                <Checkbox
                  checked={userData?.autoWhitelistAllCustomers}
                  onChange={(e) =>
                    setUserData({
                      ...userData,
                      autoWhitelistAllCustomers: e.target.checked,
                    })
                  }
                >
                  <span className="fw-semibold">Auto Whitelist All Customers</span>
                </Checkbox>
              </div>
            </Col>
          </Row>
        </div>

        {(currentUser?.role === "Super-admin" || (currentUser?.role === "Admin" && userData?.role === "Supervisor")) && (
          <div className="mt-2">
            <h6 className="fw-semibold mb-2">Permissions</h6>
            <Row className="g-2">
              {permissions.map((i, index) => (
                <Col md={6} key={index}>
                  <div className="border rounded p-2 d-flex align-items-center bg-light">
                    <Checkbox
                      checked={i.value}
                      onChange={(e) => handlePermissionChange(e, index)}
                    >
                      {i.name}
                    </Checkbox>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        )}

        <div className="d-flex justify-content-end mt-2">
          <GeneralButton
            title="Cancel"
            className="white-button mx-2"
            width="140px"
            handleClick={toggle}
          />
          <GeneralButton
            title="Save"
            className="blue-button"
            width="140px"
            handleClick={handleUserUpdate}
          />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default UpdateUserModal;
